import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketCreateReturnEventName = 'CREATE_RETURN';

export const useTrackCreateReturnClick = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketCreateReturnEventName, {
      env: environment,
    });
  }, []);
};
